import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Row,
  Col,
  Input,
  Button
} from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import * as DefautUtil from '@common/util/defaultValues';
import { acessoPermitido } from '../../acessos.seguranca';
import * as acessos from '../../acessos.const.util';
import * as actions from './tarefas.action';
import SelectComponent from '@componentes/select/select.component';
import IntlMessage from "../../helpers/intlMessage";
import { useIntl } from 'react-intl';
import ModalLiberacaoLote from './tarefas.liberacaolote.page';

const TaretasFiltroPage = props => {
  const intl = useIntl()
  const dispatch = useDispatch();
  const tarefas = useSelector(state => state.tarefas);
  const [dropdownOpenOrdenacao, setDropdownOpenOrdenacao] = useState(false);
  const [isloaded, setIsloaded] = useState(false);
  const [ordenacaoSelecionada, setOrdenacaoSelecionada] = useState(DefautUtil.enumFiltroListOrder(intl)[0]);
  const [showModalLiberacaoLote, setShowModalLiberacaoLote] = useState(false);

  useEffect(() => {
    setIsloaded(!isloaded);
  }, []);

  useEffect(() => {
    dispatch(actions.ordenacao(ordenacaoSelecionada.value));
    isloaded && filtrar();
  }, [ordenacaoSelecionada]);

  function showInput(value) {
    switch (value) {
      case DefautUtil.enumFiltroTipo.NR_EXAME:
      case DefautUtil.enumFiltroTipo.NR_PEDIDO:
      case DefautUtil.enumFiltroTipo.NOME_PACIENTE:
      case DefautUtil.enumFiltroTipo.OBSERVACAO_LAUDO:
        return true;
      default:
        return false;
    }
  }

  function filtrar() {
    const {
      medicoSelecionado,
      tipoFiltro,
      tipoFiltroValue
    } = tarefas;
    let medico = !!medicoSelecionado ? medicoSelecionado.value : null;
    props.filtrar(
      medico,
      props.periodoInicial,
      props.periodoFinal,
      tipoFiltro,
      tipoFiltroValue,
      ordenacaoSelecionada.value
    );
  }

  return (
    <div>
      <ModalLiberacaoLote
        onModal={() =>setShowModalLiberacaoLote(!showModalLiberacaoLote)}
        showModalLiberacaoLote={showModalLiberacaoLote}
      />

      <Row className='citologia-filtro-page'>
        <Col sm={'auto'}>
          <h2 className='title-citologia'>{`${intl.formatMessage({ id: "menu.doctorTasks" })}`}</h2>
        </Col>

        <Col sm={'3'}>
          <SelectComponent
            options={props.medicos}
            value={props.medicoSelecionado}
            onChange={event => props.onChangeMedico(event)}
            placeholder={`${intl.formatMessage({ id: "dashboards.doctorTasks.selectSearchType" })}`}
            styles={{ borderColor: 'transparent' }}
            disabled={
              props.carregando ||
              !acessoPermitido(props.usuario, acessos.AcessoTotalSistema)
            }
          />
        </Col>

        <Col sm={'2'}>
          <SelectComponent
            options={DefautUtil.enumFiltroTipoList}
            value={props.tipoFiltroSelecionado}
            onChange={event => props.onChangeTipoFiltro(event)}
            placeholder={`${intl.formatMessage({ id: "dashboards.doctorTasks.selectSearchType" })}`}
            styles={{ borderColor: 'transparent' }}
          />
        </Col>
        <Col
          sm={'3'}
          style={{
            display: showInput(props.tipoFiltroSelecionado.value)
              ? 'initial'
              : 'none'
          }}
        >
          <Input
            style={{
              height: '45px',
              borderRadius: '5px',
              fontSize: '13px'
            }}
            onChange={event =>
              props.onChangeInputText(
                props.tipoFiltroSelecionado.value,
                event.target.value
              )
            }
            onKeyPress={props.onKeyPressInputText}
            value={props.tipoFiltroValue}
            disabled={props.carregando}
          />
        </Col>
        <Col
          sm={'3'}
          style={{
            display:
              props.tipoFiltroSelecionado.value !==
                DefautUtil.enumFiltroTipo.URGENTE &&
                props.tipoFiltroSelecionado.value !==
                DefautUtil.enumFiltroTipo.TIPO_EXAME
                ? 'none'
                : 'initial'
          }}
        >
          <SelectComponent
            options={props.optionsFiltroInputTypeSelect}
            placeholder={`${intl.formatMessage({ id: "dashboards.doctorTasks.selectSearchType" })}`}
            value={props.optionFiltroInputTypeSelectSelecionada}
            onChange={event => props.onChangeSelect(event)}
            styles={{ borderColor: 'transparent' }}
            disabled={props.carregando}
          />
        </Col>

        <Col
          sm={'auto'}
          style={{
            padding: 0,
            display:
              props.tipoFiltroSelecionado.value !==
                DefautUtil.enumFiltroTipo.DATA_ENTREGA &&
                props.tipoFiltroSelecionado.value !==
                DefautUtil.enumFiltroTipo.DATA_SOLICITACAO
                ? 'none'
                : 'initial'
          }}
        >
          <Row>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'auto', width: 'auto' }}>
            <div className="label-data-tarefas-medico"><IntlMessage id="period.name"/></div>
            <div className="form-group-tarefas-medico" style={{width: '200px', display: 'block'}}>
              <SelectComponent
                isClearable
                className="filtro-data"
                noOptionsMessage={`${intl.formatMessage({id: "dashboards.reports.noItemsFound"})}`}
                name="form-field-period"
                placeholder={`${intl.formatMessage({id: "dashboards.general.selectPeriod"})}`}
                value={props.periodo}
                onChange={(e) => {
                  props.onChangePeriodo(e);
                  e && e.value ? props.mudarIntervaloPeriodo(e.value) : props.mudarIntervaloPeriodo('todos');
                }}
                options={props.periodos}
              />
            </div>

            {props.periodo && props.periodo.value === 'outro' && (
              <React.Fragment>
                <DebounceInput
                  name="periodoDe"
                  type="date"
                  style={{width: '130px', display: 'block'}}
                  className="filtro-data"
                  value={props.periodoInicial}
                  onChange={(value) => {props.onChangeData('periodoInicial', value.target.value)}}
                  onKeyPress={(e) => props.onKeyPressData(e)}
                />
                <DebounceInput
                  name="periodoAte"
                  type="date"
                  style={{width: '130px', display: 'block'}}
                  className="filtro-data"
                  value={props.periodoFinal}
                  onChange={(value) => {props.onChangeData('periodoFinal', value.target.value)}}
                  onKeyPress={(e) => props.onKeyPressData(e)}
                />
              </React.Fragment>
            )}
            </div>
          </Row>
        </Col>

        <Col sm={'auto'}>
          <Button
            className='btn btn-primary'
            onClick={() => filtrar()}
            style={{ height: '38px', width: '38px' }}
            disabled={props.carregando}
          >
            <i className='icons-btn mv-basico-pesquisar'></i>
          </Button>
        </Col>

        <Col sm='auto' style={{display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            className='btn btn-primary'
            onClick={() => setShowModalLiberacaoLote(!showModalLiberacaoLote)}
            style={{ height: '38px' }}
          >
            <i className='mv-basico-dados_solicitacao' style={{marginRight: '7px'}}></i>
            <IntlMessage id="dashboards.doctorTasks.releaseBatchReports" />
          </Button>
        </Col>
      </Row>
      <Row className='tarefas-ordem-filtro'>
        <Col sm='auto'>
          <Label><IntlMessage id="dashboards.general.orderBy" /> </Label>
          <Dropdown
            style={{ display: 'inline' }}
            isOpen={dropdownOpenOrdenacao}
            toggle={() => setDropdownOpenOrdenacao(!dropdownOpenOrdenacao)}
          >
            <DropdownToggle
              color='#fff'
              className='button'
              caret
              style={{ borderColor: 'transparent' }}
            >
              {ordenacaoSelecionada.label}
            </DropdownToggle>
            <DropdownMenu right>
              {DefautUtil.enumFiltroListOrder(intl).map((ordem, i) => (
                <DropdownItem
                  key={i}
                  onClick={() => setOrdenacaoSelecionada(ordem)}
                >
                  {ordem.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
    </div>
  );
};
export default TaretasFiltroPage;



// WEBPACK FOOTER //
// ./src/pages/tarefas/tarefas.filtro.page.js